import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import className from 'classnames';
import serviceList from 'data/feature/serviceList';
import Section from 'components/common/Section';
import SectionHeader from './SectionHeader';
import { BsTranslate, BsFillClipboardPlusFill } from 'react-icons/bs';
import { LiaConnectdevelop } from 'react-icons/lia';
import { CiBoxList, CiMonitor } from 'react-icons/ci';
import { GoPeople, GoRepoPush, GoGraph, GoRepoLocked } from 'react-icons/go';
import { MdHelpCenter } from 'react-icons/md';
import { TbSeo } from 'react-icons/tb';
import { BiCloudDownload } from 'react-icons/bi';

const Services = () => {
  const getIcons = name => {
    switch (name) {
      case 'BsTranslate':
        return <BsTranslate />;
      case 'BsFillClipboardPlusFill':
        return <BsFillClipboardPlusFill />;
      case 'LiaConnectdevelop':
        return <LiaConnectdevelop />;
      case 'CiBoxList':
        return <CiBoxList />;
      case 'GoPeople':
        return <GoPeople />;
      case 'CiMonitor':
        return <CiMonitor />;
      case 'GoRepoPush':
        return <GoRepoPush />;
      case 'GoGraph':
        return <GoGraph />;
      case 'GoRepoLocked':
        return <GoRepoLocked />;
      case 'MdHelpCenter':
        return <MdHelpCenter />;
      case 'TbSeo':
        return <TbSeo />;
      case 'BiCloudDownload':
        return <BiCloudDownload />;
      default:
        return <BsTranslate />;
    }
  };

  return (
    <Section bg="light" className="text-center">
      <SectionHeader
        title=" Системийн боломжууд "
        subtitle="Бизнесийн онцлогтоо тохирох ашиглахад хялбар олон боломжуудтай бүтээгдэхүүн үйлчилгээг ашиглан хялбараар өөрийн веб сайтөө бүтээгээрэй."
      />
      <Row className="mt-6">
        {serviceList.map((service, index) => (
          <Col
            lg={4}
            className={className({ 'mt-6 mt-lg-6': index > -1 })}
            key={index}
          >
            <Card className="card-span h-100 ">
              <div
                className={`card-span-img bg-soft-${service?.median?.color}`}
              >
                <div
                  className={className(
                    {
                      [`text-${service?.media?.color}`]: service?.media?.color
                    },
                    service?.media?.className
                  )}
                >
                  {getIcons(service?.media?.icon)}
                </div>
              </div>
              <Card.Body className="pt-6 pb-4">
                <p className="lead">{service?.title}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Section>
  );
};

export default Services;
